import { render, staticRenderFns } from "./shareholder-form.vue?vue&type=template&id=66c0d834"
import script from "./shareholder-form.vue?vue&type=script&lang=js"
export * from "./shareholder-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports